import React, { Component } from 'react';
import MockAPI from "../../mocks/MockAPI";
import "./Project.css";
import TitleMdLg from './TitleMdLg';
import TitleXsSm from './TitleXsSm';
import SecondaryNav from './SecondaryNav';
import Deliverable from './Deliverable';
import DeliverableXs from './DeliverableXs';


export default class Project extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0,
      activeMediaIndex: 0,
      count: 0,
      currentDeliverable: {},
      loading: true,
      navProjectIds: {
        next: 0,
        prev: 0
      },
      project: {}
    }
  }

  // TODO move into its own function: its being used twice in the same way
  async componentDidMount() {

    try {
      const project = await this.getProject();
      this.setState({
        count: project.count,
        loading: false,
        navProjectIds: {
          next: project.nextProjectId,
          prev: project.prevProjectId
        },
        project: project.data,
      });
    } catch (e) {
      alert(e);
    }
  }

  async componentDidUpdate(prevProps, prevState) {

    if (this.props.match.params.id !== prevProps.match.params.id) {
      try {
        const project = await this.getProject();
        this.setState({
          activeTabIndex: 0,
          activeMediaIndex: 0,
          count: project.count,
          loading: false,
          navProjectIds: {
            next: project.nextProjectId,
            prev: project.prevProjectId
          },
          project: project.data,
        });
      } catch (e) {
        alert(e);
      }
    }
  }

  async getProject() {
    this.setState({ loading: true });
    let project = await MockAPI.get(this.props.match.params.id, this.props.category);
    return project;
  }


  handleDeliverableToggle = (tabIndex, event) => {
    event.preventDefault();
    this.setState({
      activeTabIndex: tabIndex,
      activeMediaIndex: 0
    });
  }

  handleMediaToggle = (index, event) => {
    this.setState({ activeMediaIndex: index });
  }




  render() {

    return (
      <div className="Project container">

        {/* MD, LG: Project Title and Next Project link. */}
        <TitleMdLg {...this.state}></TitleMdLg>


        {/* XS, SM: Project Title. SM: Project Navigation Chevron.  */}
        <TitleXsSm {...this.state}></TitleXsSm>


        {/* All but XS: Secondary navigation menu. */}
        <SecondaryNav {...this.state} handleDeliverableToggle={this.handleDeliverableToggle}></SecondaryNav>


        {/* All but XS: Project component body  */}
        <Deliverable {...this.state} handleMediaToggle={this.handleMediaToggle}></Deliverable>


        {/* XS: Secondary navigation menu and body */}
        <DeliverableXs {...this.state} handleDeliverableToggle={this.handleDeliverableToggle} handleMediaToggle={this.handleMediaToggle}></DeliverableXs>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Project/Project.js